import {toggle_loader, disable_loader} from '../../theme/_loader';

document.addEventListener("DOMContentLoaded", function ($ = jQuery) {
	var $ = require('jquery');
	const select2 = require('select2');

	//Select2 instances which we don't need a search for
	$('select.ff-el-form-control:not(.ff_has_multi_select), select.tyre-search-results-select').select2({
		minimumResultsForSearch: -1,
		dropdownParent: $('#select2-focus-container')
	});

	//Select2 instances which we don't need a search for
	$('select#post-category, #open-tyre-size select, .cta-tyre-size select, #location-category, #role-category').select2({
		minimumResultsForSearch: 2,
		dropdownParent: $('#select2-focus-container')
	});

	//Select2 instances on the Tyre Search that have a callback
	$('#open-tyre-size select, .cta-tyre-size select').on("select2:open", function (e) {

		let selected_items = false;

		if((e.target).classList.contains('search-width')) { //if this is a width select
			selected_items = document.querySelectorAll('.preview-width');
            $('input.select2-search__field').prop('placeholder', 'Width');
		} else if((e.target).classList.contains('search-profile')) { //if this is a profile select
			selected_items = document.querySelectorAll('.preview-profile');
            $('input.select2-search__field').prop('placeholder', 'Profile');
		} else if((e.target).classList.contains('search-rim')) { //if this is a rim select
			selected_items = document.querySelectorAll('.preview-rim');
            $('input.select2-search__field').prop('placeholder', 'Rim');
		} else if((e.target).classList.contains('search-speed')) { //if this is a speed select
			selected_items = document.querySelectorAll('.preview-speed');
            $('input.select2-search__field').prop('placeholder', 'Speed');
		}

        //focus on the search field
		document.querySelector('.select2-search__field').focus();

        //if we have some selected items
		if(selected_items) {

            for(let i = 0; i < selected_items.length; i++) {
                selected_items[i].classList.add('text-primary');
            }
		}
	});

	$('#open-tyre-size select, .cta-tyre-size select').on("select2:close", function (e) {
		let selected_items = false;

		if((e.target).classList.contains('search-width')) { //if this is a width select
			selected_items = document.querySelectorAll('.preview-width');
		} else if((e.target).classList.contains('search-profile')) { //if this is a profile select
			selected_items = document.querySelectorAll('.preview-profile');
		} else if((e.target).classList.contains('search-rim')) { //if this is a rim select
			selected_items = document.querySelectorAll('.preview-rim');
		} else if((e.target).classList.contains('search-speed')) { //if this is a speed select
			selected_items = document.querySelectorAll('.preview-speed');
		}

		if(selected_items && !isNaN((e.target).value)) {

            for(let i = 0; i < selected_items.length; i++) {
                selected_items[i].innerHTML = (e.target).value;
            }
		}

		let preview_texts = document.getElementsByClassName('tyre-preview-text');

		if(preview_texts) {
			for(let i = 0; i < preview_texts.length; i++) {
				preview_texts[i].classList.remove('text-primary');
			}
		}
	});

	$('#sort-shortcut, #sort-shortcut-alt').on("select2:select", function (e) {
		let filter = document.getElementById('tyre-search-results-fields');

		if(filter) {
			let sort = document.getElementById('sort');

			if(sort) {
				sort.value = (e.target).value;
				toggle_loader();
				filter.submit();
			}
		}
	});

	$('#services-grid-controls select').on("select2:select", function (e) {
		let grid = document.getElementById('services-grid');

		if(grid) {
			grid.dataset.visible_type = (e.target).value;
		}
	});

	//if this is the custom products archive
	if(document.body.classList.contains('post-type-archive-products')) {

		//get all custom selects on this page
		let product_selects = document.getElementsByClassName('custom-product-select');

		//loop over each product select
		for(let i = 0; i < product_selects.length; i++) {

			//initialize it
			$(product_selects[i]).select2({
				minimumResultsForSearch: -1,
				dropdownParent: $('#select2-focus-container-dark')
			});
		}

		$('body.post-type-archive-products select[name="order"]').select2({
			minimumResultsForSearch: -1,
			dropdownParent: $('#select2-focus-container')
		});
	}
});